import type {TabCredentials} from './tabSession';

/** The token a request presents to our server: the access token for both Auth0 and Zitadel. Its
 * audience is the API the Rust server checks (the Auth0 API or the Zitadel Practice project); the ID
 * token's audience is the browser app, which the server refuses (OWA-1137, OWA-1284). */
export function serverCredential(credentials: TabCredentials): string {
    return credentials.accessToken;
}
